import React, { useEffect, useState } from "react";
import { getAllCPs } from "../../../apis/chargingPointsApi";
import { Table } from "antd";
import getCPsColumns from "../../../const/Columns/getCPsColumns";

const ChargerPoints = () => {
  const [cps, setCPs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [cpId, setCpId] = useState();
  const [status, setStatus] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalItems, setTotalItems] = useState(0);

  useEffect(() => {
    fetchCPs(null, {
      page: currentPage,
      limit: pageSize,
      filters: { cpId, status },
    });
  }, [currentPage, pageSize, cpId, status]);

  const fetchCPs = async (id, body) => {
    setLoading(true);
    try {
      const res = await getAllCPs(id, body);
      setCPs(res.result?.data);
      setTotalItems(res?.result?.totalRecords);
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const handleTableChange = (pagination) => {
    setCurrentPage(pagination.current);
    setPageSize(pagination.pageSize);
  };

  const columns = getCPsColumns();
  return (
    <>
      <div className="main-wrapper">
        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="d-flex  justify-content-between  align-items-center">
              {/* <Link to="" className="btn add-new btn-primary mb-3">
                Add Charging Point
              </Link> */}
              {/*search box*/}
              <div className="d-flex flex-column w-25">
                <label htmlFor="userIdInput" className="form-label">
                  Search By cp
                </label>
                <input
                  type="text"
                  placeholder="Search by cpId"
                  className="form-control w-20"
                  value={cpId}
                  onChange={(e) => setCpId(e.target.value)}
                />
              </div>
              <div className="d-flex flex-column w-25">
                <label htmlFor="userIdInput" className="form-label">
                  Search By Status
                </label>
                <input
                  type="text"
                  placeholder="Search by status"
                  className="form-control w-20"
                  value={status}
                  onChange={(e) => setStatus(e.target.value)}
                />
              </div>
            </div>
            {loading ? (
              <div>Loading...</div>
            ) : (
              <div className="table-respoinsive" style={{ overflowX: "auto" }}>
                <Table
                  columns={columns}
                  dataSource={cps?.length > 0 ? cps : []}
                  pagination={{
                    current: currentPage,
                    pageSize: pageSize,
                    total: totalItems,
                    showSizeChanger: true,
                    pageSizeOptions: ["10", "20", "50", "100"],
                  }}
                  onChange={handleTableChange}
                  className="table-striped"
                  rowKey={(record) => record.id}
                  // scroll={{ y: 400 }}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default ChargerPoints;
